import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared.module';
import { GridUsersListModule } from 'src/app/views/grid-user-list/grid-users-list.module';
import { SortElementsModule } from 'src/app/views/sort-elements/sort-elements.module';
import { TableUsersListModule } from 'src/app/views/table-users-list/table-users-list.module';
import { ViewsModule } from 'src/app/views/views.module';
import { ConnectionsPageComponent } from './components/connections-page/connections-page.component';
import { DoctorLinksPageComponent } from './components/doctor-links-page/doctor-links-page.component';
import { RelatedUserMessageComponent } from './components/group-messaging-page/user-group-messaging.component';
import { ManageRelationRequestComponent } from './components/manage-relation-request/manage-relation-request.component';
import { PatientLinksPageComponent } from './components/patient-links-page/patient-links-page.component';
import { RelationGeographyComponent } from './components/relation-geography/relation-geography.component';

@NgModule({
  declarations: [
    ConnectionsPageComponent,
    DoctorLinksPageComponent,
    PatientLinksPageComponent,
    ManageRelationRequestComponent,
    RelatedUserMessageComponent,
    RelationGeographyComponent,
  ],
  imports: [
    SharedModule,
    ViewsModule,
    NgbCollapseModule,
    TableUsersListModule,
    NgbPaginationModule,
    GridUsersListModule,
    SortElementsModule,
  ],
  exports: [RelationGeographyComponent],
})
export class UserRelationRequestModule {}
